import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import OpenCalls from "./AICalls/OpenCalls";
import CompletedCalls from "./AICalls/CompletedCalls";
import PageStatsCards from "../../reusable-components/PageStatsCards";

export default function AICalls() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTabStatus = searchParams.get("subtab");
  const [complCallsStats, setComplCallsStats] = useState(null);
  const [selComplCallAppoint, setSelComplCallAppoint] = useState(null);
  const [callsTabStat, setCallsTabStat] = useState(urlTabStatus || "active");

  return (
    <>
      <div
        className={`${selComplCallAppoint ? "px-3 mx-3" : "px-3 py-6 mx-3"}`}
      >
        {!selComplCallAppoint && (
          <>
            {callsTabStat === "completed" && complCallsStats != null && (
              <PageStatsCards
                PageName="CompletedCalls"
                CardsData={complCallsStats}
              />
            )}
            <div className="mt-4 border-b border-gray-200">
              <div className="flex w-full">
                <TabLink
                  label="Open Calls"
                  navigateTab={() => {
                    setCallsTabStat("active");
                    setSearchParams((prev) => {
                      prev.set("subtab", "active");
                      return prev;
                    });
                  }}
                  isActive={callsTabStat === "active"}
                  className="flex-1 text-xl font-extrabold"
                />
                <TabLink
                  label="Completed Calls"
                  navigateTab={() => {
                    setCallsTabStat("completed");
                    setSearchParams((prev) => {
                      prev.set("subtab", "completed");
                      return prev;
                    });
                  }}
                  isActive={callsTabStat === "completed"}
                  className="flex-1 text-xl font-extrabold"
                />
              </div>
            </div>
          </>
        )}
        {callsTabStat === "active" && <OpenCalls />}
        {callsTabStat === "completed" && (
          <CompletedCalls
            SelComplAppoint={selComplCallAppoint}
            SetSelComplAppoint={setSelComplCallAppoint}
            SetComplCallsStats={setComplCallsStats}
          />
        )}
      </div>
    </>
  );
}

const TabLink = ({ label, navigateTab, isActive, className = "" }) => {
  const baseClasses =
    "inline-block py-2 px-3 text-center border-b-2 font-medium text-sm";
  const activeClasses = "border-blue-500 text-blue-600";
  const inactiveClasses =
    "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300";
  return (
    <button
      onClick={navigateTab}
      className={`${baseClasses} ${
        isActive ? activeClasses : inactiveClasses
      } ${className} relative w-full`}
    >
      <div className="flex items-center justify-center w-full">
        <span className="text-center">{label}</span>
      </div>
    </button>
  );
};
